import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpService} from '@core/backend/common/api/http.service';

@Injectable()
export class ProxyStreamApi {
    constructor(private api: HttpService) {}

    private readonly prefix = 'proxy';

    public mediaFileStreaming(signedUrl: string): Observable<Blob> {
        return this.api.post(
            `${this.prefix}/media/streaming-proxy`,
            {url: signedUrl},
            {
                responseType: 'blob' as 'json',
            },
        );
    }
}
